/* eslint-disable */
import React from 'react';
import validator from 'validator';

export const api = value => (
    <button className="error">
        API Error on {value} value. Focus to hide.
    </button>
);

export const required = value => {
    if (!value?.toString().trim().length) {
        return <span className="error">Required</span>;
    }
};

export const alpha = value => {
    if (!validator.isAlpha(value)) {
        return <span className="error">Numbers are not allowed.</span>;
    }
};

export const fullName = value => {
    if (
        value
            .toString()
            .split(' ')
            .filter(i => i).length < 2
    ) {
        return <span className="error">Please provide your full name.</span>;
    }
};

export const phone = value => {
    const isUkPhone = /^0([1257])[0-9]{8,9}$/.test(value);
    if (!isUkPhone) {
        return <span className="error">Please enter a valid UK phone number in the form 0xxxxxxxxxx</span>;
    }
};

export const postcode = value => {
    if (!validator.isPostalCode(value, 'GB')) {
        return <span className="error">Please enter a valid UK postcode</span>;
    }
}

export const email = value => {
    if (!validator.isEmail(value)) {
        return <span className="error">Not a valid email.</span>;
    }
};

export const password = (value, props, components) => {
    const password = components.password.state;
    const passwordConfirm = components.passwordConfirm.state;
    const isBothUsed =
        password &&
        passwordConfirm &&
        password.isUsed &&
        passwordConfirm.isUsed;
    const isBothChanged =
        isBothUsed && password.isChanged && passwordConfirm.isChanged;

    if (!isBothUsed || !isBothChanged) {
        return true;
    }

    if (password.value === passwordConfirm.value) {
        return <span className="error">Passwords should be equal.</span>;
    }
};
